//Slick
const $hotelFullSlider = $('.js-slider-hotel-full');
const $hotelSlider  = $('.js-slider-hotel');
const $rentalSlider = $('.js-rental-slider');
const $usageSlider  = $('.js-slider-usage');
const $eventArchiveSlider = $('.js-event-archive-slider');

// クラス名が'js-tab-change-link'のすべての要素を取得
const links = document.querySelectorAll('.js-tab-change-link');

// クラス名が'js-tab-change-item'のすべての要素を取得
const items = document.querySelectorAll('.js-tab-change-item');

if(links.length > 0 && items.length > 0){
	
	// すべてのitem非表示
	items.forEach(item => {
		item.style.display = 'none';
	});

	// 'is-active'クラスを持つリンクのインデックスを探す
	const activeLinkIndex = Array.from(links).findIndex(link => link.classList.contains('is-active'));

	if(activeLinkIndex > 0){
		// is-activeが付いた要素の順番のタブを表示する
		items[activeLinkIndex].style.display = 'block';
	} else {
		// 1番目の要素のみを表示する
		items[0].style.display = 'block';
		links[0].classList.add('is-active');
	}

	// 各リンクにイベントリスナーを追加
	links.forEach((link, index) => {
		link.addEventListener('click', function(event) {
			event.preventDefault();
			//切り替えリンクのclass削除
			links.forEach(item => {
				item.classList.remove('is-active');
			});

			//クリックした切り替えリンクにclass追加
			link.classList.add('is-active');

			//すべてのitem非表示
			items.forEach(item => {
				item.style.display = 'none';
			});

			//同じindexのitemを表示
			items[index].style.display = 'block';

			//Slick
			$rentalSlider.slick('setPosition');
			$usageSlider.slick('setPosition');
			$hotelSlider.slick('setPosition');
			$hotelFullSlider.slick('setPosition');
			$eventArchiveSlider.slick('setPosition');
		});
	});
}
